module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 60
// module chunks = 140